/** The type of dataset to plot */
export enum DatasetType {
    analog = 'ANALOG',
    discrete = 'DISCRETE',
    eventTable = 'EVENT_TABLE',
    image = 'IMAGE'
}
